module.exports = __webpack_public_path__ + "muchosol-logo.png?7498a4e873794d544f0eab29404b112a";